


























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class WrapperSimpleComponent extends Vue {
  @Prop({
    default: false
  })
  public horizontalContent: boolean;

  private hasControls(): boolean {
    return !!this.$slots.controls;
  }
}
